import { render, staticRenderFns } from "./Novelties.vue?vue&type=template&id=35e98742&scoped=true&"
import script from "./Novelties.vue?vue&type=script&lang=js&"
export * from "./Novelties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e98742",
  null
  
)

export default component.exports